// Uploaded course videos stream; documents and embedded links keep their own paths.
export const isStreamableCourseVideo = item => item?.type === 'video';
